import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useParams } from 'react-router-dom'
import { useGetCoursesQuery } from './coursesApiSlice'
import { memo } from 'react'

const Course = ({ courseId }) => {
    const {groupId, type} = useParams()
    const { course } = useGetCoursesQuery("coursesList", {
        selectFromResult: ({ data }) => ({
            course: data?.entities[courseId]
        }),
    })

    const navigate = useNavigate()

    if (course) {
        const handleEdit = () => navigate(`/${type}/${groupId}/courses/${courseId}`)

        return (
            <tr className="table__row">
                <td className="table__cell course__name">{course.name}</td>
                <td className="table__cell course__active">{course.active?"true":"false"}</td>

                <td className="table__cell">
                    <button
                        className="icon-button table__button"
                        onClick={handleEdit}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                </td>
            </tr>
        )

    } else return null
}

const memoizedCourse = memo(Course)

export default memoizedCourse